export default __webpack_public_path__ + "static/media/meta-page.4e7360cc.png";